$(document).ready(function() {   
// Home banner slider
$('.home_slider').slick({
        dots: true,
        fade:true,
        infinite: true,
        arrows:true, 
        autoplay: true,
         adaptiveHeight: true,
        speed: 700,
		autoplaySpeed: 8000,
        slidesToShow: 1,
        slidesToScroll: 1,
		 responsive: [
		{
		  breakpoint: 767,
		  settings: {
			arrows:false, 
		  }
		}
	   ]
    });
  $('a[href="#"]').attr('href', 'javascript:void(0)');  

$('.brand-slider').slick({
	  dots: false,
	  infinite: true,
	  arrow:false,
	  speed:22000,
	  centerMode: false,
	  slidesToShow:1,
		variableWidth: true,
	  slidesToScroll: 1,
	  cssEase: 'linear',
	  autoplay: true,
	  autoplaySpeed: 0,
	  responsive: [
		{
		  breakpoint: 991,
		  settings: {
			slidesToShow: 1,
			slidesToScroll: 1
		  }
		},
		{
		  breakpoint: 767,
		  settings: {
			slidesToShow: 1,
			slidesToScroll: 1
		  }
		}
	   ]
});

  $('.review-slider').slick({
        dots: false,
        fade:false,
        infinite: true,
        centerMode: false,
        arrows:true, 
		appendArrows: $('.review-arrows'),
        autoplay: true,
        adaptiveHeight: false,
        centerPadding: '32px',
        autoplaySpeed: 5500,
        speed: 1200,
        slidesToShow: 3,
        pauseOnHover: false,
        pauseOnFocus: false,
        slidesToScroll: 1,
		 responsive: [
			{
		  breakpoint: 1100,
		  settings: {
			slidesToShow: 2,
			slidesToScroll: 1
		  }
		},
		{
		  breakpoint: 767,
		  settings: {
			slidesToShow: 1,
			slidesToScroll: 1
		  }
		}
	   ]
    });
  

  $('.press-slider').slick({
	  dots: false,
	  infinite: true,
	  arrow:false,
	  speed:22000,
	  centerMode: false,
	  slidesToShow:1,
		variableWidth: true,
	  slidesToScroll: 1,
	  cssEase: 'linear',
	  autoplay: true,
	  autoplaySpeed: 0,
	  responsive: [
		{
		  breakpoint: 991,
		  settings: {
			slidesToShow: 1,
			slidesToScroll: 1
		  }
		},
		{
		  breakpoint: 767,
		  settings: {
			slidesToShow: 1,
			slidesToScroll: 1
		  }
		}
	   ]
});

  $('.text-slider').slick({
	  dots: false,
	  infinite: true,
	  arrow:false,
	  speed:15000,
	  centerMode: false,
	  slidesToShow:1,
		variableWidth: true,
	  slidesToScroll: 1,
	  cssEase: 'linear',
	  autoplay: true,
	  autoplaySpeed: 0,
	  responsive: [
		{
		  breakpoint: 991,
		  settings: {
			slidesToShow: 1,
			slidesToScroll: 1
		  }
		},
		{
		  breakpoint: 767,
		  settings: {
			slidesToShow: 1,
			slidesToScroll: 1
		  }
		}
	   ]
});


var $swiperSelector = $('.swiper-container');

$swiperSelector.each(function (index) {
  var $this = $(this);
  $this.addClass('swiper-slider-' + index);

  var dragSize = $this.data('drag-size') ? $this.data('drag-size') : 180;
  var freeMode = $this.data('free-mode') ? $this.data('free-mode') : false;
  var loop = $this.data('loop') ? $this.data('loop') : false;
  var slidesDesktop = $this.data('slides-desktop') ? $this.data('slides-desktop') : 4;
  var slidesLap = $this.data('slides-Lap') ? $this.data('slides-lap') : 4;
  var slidesTablet = $this.data('slides-tablet') ? $this.data('slides-tablet') : 3;
  var slidesMobile = $this.data('slides-mobile') ? $this.data('slides-mobile') : 3;
  var spaceBetween = $this.data('space-between') ? $this.data('space-between') : -2;

  var swiper = new Swiper('.swiper-slider-' + index, {
    direction: 'horizontal',
    loop: loop,
    freeMode: freeMode,
    spaceBetween: 24,
    breakpoints: {
      1920: {
        slidesPerView: slidesDesktop },

      1150: {
        slidesPerView: slidesLap },

      992: {
        slidesPerView: slidesTablet },

      767: {
        slidesPerView: slidesMobile } },


    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev' },

    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true,
      dragSize: dragSize } });


});
//# sourceURL=pen.js

  
});

$(window).on("load resize",(function(){
    var sheight = $(".review-sliderwrap").height();	      
 	 $(".review-box").css("min-height", sheight);
}));

